import AppBar from '@material-ui/core/AppBar';
import HeaderHelp from './HeaderHelp';
import HeaderHikes from './HeaderHikes';
import HeaderLogin from './HeaderLogin';
import HeaderMap from './HeaderMap';
import HeaderMembership from './HeaderMembership';
import HeaderNotifications from './HeaderNotifications';
import HeaderAnnouncement from './HeaderAnnouncement';
import HeaderSignup from './HeaderSignup';
import HeaderUser from './HeaderUser';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import theme from '../../theme';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import withWidth from '@material-ui/core/withWidth';
import {GRANITE_2} from '../../colors';
import fetchUser from '../../utils/gaia/fetchUser';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

const linkStyle: React.CSSProperties = {
    outline: 0,
    border: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    borderBottomColor: theme.palette.primary.main,
    borderBottomStyle: 'solid',
    alignItems: 'center',
    color: GRANITE_2,
    textDecoration: 'none',
    fontSize: 14,
};

const buttonStyle: React.CSSProperties = {
    marginLeft: theme.spacing(2),
    fontSize: 14,
    outline: 0
};

interface HeaderState {
    hamburgerOpen: boolean;
    user: User | undefined;
}

class Header extends React.Component<{width: string}, HeaderState> {

    hamburgerRef: React.RefObject<HTMLAnchorElement>;

    constructor(props: {width: string}) {
        super(props);

        this.hamburgerRef = React.createRef();
        this.state = {hamburgerOpen: false, user: undefined};
    }

    async componentDidMount() {
        this.setState({user: await fetchUser()});
    }

    render() {
        return <>
            <AppBar
                elevation={0}
                color="default"
                position="static"
                style={{boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.1)'}}
            >
                <Toolbar style={{boxSizing: 'border-box'}}>
                    <a href="/" style={{
                        // eslint-disable-next-line max-len
                        background: `url(${Gaia.staticURL}img/logos_icons/gaia_gps_logo.svg) left center no-repeat`,
                        width: 200,
                        height: 41,
                        backgroundSize: '200px 41px',
                        marginRight: 18,
                        marginLeft: 0,
                        marginBottom: 0,
                    }} />

                    <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'stretch',
                        alignSelf: 'stretch',
                    }}>
                        {this.renderLeftButtons()}
                    </div>

                    {this.renderAppIcons()}
                    {this.renderRightButtons()}
                    {this.renderHamburgerButton()}
                    {this.renderHamburgerMenu()}
                </Toolbar>
            </AppBar>
            {this.getGiftBanner()}
        </>;
    }

    getGiftBanner() {
        //turn gift banner on during december
        const d = new Date();
        const month = d.getMonth();
        const december = 11;
        if (month === december) {
            return <HeaderAnnouncement />;

        }
    }

    renderAppIcons() {
        const {user} = this.state;
        const {width} = this.props;
        const style = {...buttonStyle, height: 34, verticalAlign: 'middle'};

        if (!user || !user.isAuthenticated || user.hasMobileApp || width === 'xs') return null;

        return (<React.Fragment>
            <a
                href={'https://itunes.apple.com/us/app/gaia-gps/id1201979492?mt=8&uo=4'}
                target="itunes_store"
                onClick={() => trackAnalytics('Buy iOS', {
                    category: 'Commerce',
                    label: 'Header',
                    page: window.location.href
                })}
            >
                <img
                    style={style}
                    src={`${Gaia.staticURL}img/appstore.svg`}
                    alt="Download on the App Store"
                />
            </a>

            <a
                // eslint-disable-next-line max-len
                href="https://market.android.com/details?id=com.trailbehind.android.gaiagps.pro&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackAnalytics('Buy Android', {
                    category: 'Commerce',
                    label: 'Header',
                    page: window.location.href
                })}
            >
                <img
                    style={style}
                    src={`${Gaia.staticURL}img/icons/play_badge.png`}
                    alt="Get it on Google Play"
                />
            </a>
        </React.Fragment>);
    }

    renderLeftButtons() {
        if (this.isHamburgerVisible()) return null;

        return (<React.Fragment>
            <HeaderMap.Toolbar style={linkStyle} />
            <HeaderHikes.Toolbar style={linkStyle} />
            <HeaderHelp.Toolbar style={linkStyle} />
            <HeaderMembership.Toolbar style={linkStyle} />
        </React.Fragment>);
    }

    renderRightButtons() {
        if (this.isHamburgerVisible()) return null;

        return (<React.Fragment>
            <HeaderLogin.Toolbar style={buttonStyle} />
            <HeaderSignup.Toolbar style={buttonStyle} />
            <HeaderNotifications.Toolbar style={linkStyle} />
            <HeaderUser.Toolbar style={linkStyle} />
        </React.Fragment>);
    }

    renderHamburgerButton() {
        if (!this.isHamburgerVisible()) return null;

        return (<a
            style={{...linkStyle, paddingRight: 0}}
            ref={this.hamburgerRef}
            href='#'
            onClick={event => {
                event.preventDefault();
                this.setState({hamburgerOpen: true});
            }}
        ><MenuIcon /></a>);
    }

    renderHamburgerMenu() {
        if (!this.isHamburgerVisible()) return null;

        return (<Menu
            anchorEl={this.hamburgerRef.current}
            open={this.state.hamburgerOpen}
            onClose={() => this.setState({hamburgerOpen: false})}
        >
            <HeaderMap.HamburgerMenu />
            <HeaderHikes.HamburgerMenu />
            <Divider />
            <HeaderHelp.HamburgerMenu />
            <HeaderMembership.HamburgerMenu />
            <Divider />
            <HeaderLogin.HamburgerMenu />
            <HeaderSignup.HamburgerMenu />
            <HeaderNotifications.HamburgerMenu />
            <HeaderUser.HamburgerMenu />

        </Menu>);
    }

    isHamburgerVisible() {
        return this.props.width === 'sm' || this.props.width === 'xs';
    }
}

export default withWidth()(Header);
